import { apiClient } from '@/shared/api';
import type { CorrectionRequest, PaginatedResponse } from '@aegislab/shared';

export const fetchMyCorrections = async (): Promise<PaginatedResponse<CorrectionRequest>> => {
  const response =
    await apiClient.get<PaginatedResponse<CorrectionRequest>>('/attendance/correction');
  return response.data;
};

export const fetchMyPendingCorrectionsForAttendance = async (
  attendanceId: string
): Promise<PaginatedResponse<CorrectionRequest>> => {
  const response = await apiClient.get<PaginatedResponse<CorrectionRequest>>(
    '/attendance/correction',
    { params: { attendanceId } }
  );
  return response.data;
};

export const fetchMyPendingCorrections = async (
  startDate: string,
  endDate: string
): Promise<PaginatedResponse<CorrectionRequest>> => {
  const response = await apiClient.get<PaginatedResponse<CorrectionRequest>>(
    '/attendance/correction',
    { params: { status: 'PENDING', startDate, endDate } }
  );
  return response.data;
};
